import { Box } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons";
import axios from 'axios';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../theme/IntroCarousel.css";
import { Button, Fade, Skeleton, useMediaQuery } from "@mui/material";
import Background from '../images/testiomonials2.jpg';
import { Link as RouterLink, useLocation } from "react-router-dom";

const RandomTestimonial = ({ testimonials, loading }) => {

    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();
    const mobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        fade: true,
        autoplaySpeed: 8000,
    };

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById("testimonial-0");
            if (element) {
                const rect = element.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
                setIsVisible(isVisible);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    const [testimonialData, setTestimonialData] = useState(null);

    useEffect(() => {
        if (testimonials && testimonials.all_testimonials === "all") {
            axios({
                method: 'get',
                url: `${WP_API_Settings.endpoint}wp/v2/theme_testimonials`,
            })
                .then(response => {
                    if (response.data.length > 0) {
                        const testimonialPromises = response.data.map(testimonial => {
                            return Promise.all([
                                testimonial,
                                testimonial.featured_media
                                    ? axios.get(`${WP_API_Settings.endpoint}wp/v2/media/${testimonial.featured_media}`)
                                    : null,
                                testimonial.partners
                                    ? axios.get(`${WP_API_Settings.endpoint}wp/v2/partners/${testimonial.partners}?acf_format=standard&per_page=100`)
                                    : null,
                            ]);
                        });

                        Promise.all(testimonialPromises)
                            .then(dataArray => {
                                const formattedTestimonials = dataArray.map(([testimonial, mediaResponse, partnerResponse]) => {
                                    const formattedTestimonial = {
                                        ...testimonial,
                                        featuredMedia: mediaResponse ? mediaResponse.data : null,
                                        partnerLogo: partnerResponse?.data?.acf?.logo
                                            ? partnerResponse.data.acf.logo
                                            : null,
                                    };

                                    return formattedTestimonial;
                                });

                                setTestimonialData(formattedTestimonials);
                            })
                            .catch(error => {
                                console.error('Error fetching testimonial details:', error);
                            });
                    }
                })
                .catch(error => {
                    console.error('Error fetching testimonials:', error);
                });
        } else if (testimonials && testimonials.all_testimonials === "selected") {
            axios({
                method: 'get',
                url: `${WP_API_Settings.endpoint}wp/v2/theme_testimonials?include=${testimonials.select_testimonials.join(",")}`,
            })
                .then(response => {
                    if (response.data.length > 0) {
                        const testimonialPromises = response.data.map(testimonial => {
                            return Promise.all([
                                testimonial,
                                testimonial.featured_media
                                    ? axios.get(`${WP_API_Settings.endpoint}wp/v2/media/${testimonial.featured_media}`)
                                    : null,
                                testimonial.partners
                                    ? axios.get(`${WP_API_Settings.endpoint}wp/v2/partners/${testimonial.partners}?acf_format=standard&per_page=100`)
                                    : null,
                            ]);
                        });

                        Promise.all(testimonialPromises)
                            .then(dataArray => {
                                const formattedTestimonials = dataArray.map(([testimonial, mediaResponse, partnerResponse]) => {

                                    // console.log('partnerResponse', partnerResponse);

                                    const formattedTestimonial = {
                                        ...testimonial,
                                        featuredMedia: mediaResponse ? mediaResponse.data : null,
                                        partnerLogo: partnerResponse?.data?.acf?.logo || null,
                                    };

                                    return formattedTestimonial;
                                });

                                setTestimonialData(formattedTestimonials);
                            })
                            .catch(error => {
                                console.error('Error fetching testimonial details:', error);
                            });
                    }
                })
                .catch(error => {
                    console.error('Error fetching testimonials:', error);
                });
        }
    }, [testimonials]);

    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);

    const goToPrevSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
            setCurrentSlide(currentSlide - 1);
        }
    };

    const goToNextSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
            setCurrentSlide(currentSlide + 1);
        }
    };

    return (
        <>
            {loading ? (
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    sx={{
                        height: "600px",
                        width: "100%",
                        position: "relative",
                    }}
                >
                    <Skeleton
                        variant="rectangular"
                        animation="wave"
                        sx={{
                            position: "absolute",
                            right: "4%",
                            width: "35%",
                            minHeight: "330px",
                        }}
                    />
                </Skeleton>
            ) : testimonialData?.length > 0 ?
                (
                    <Slider {...settings} ref={sliderRef}>
                        {testimonialData.map((testimonial, index) => {
                            // console.log('testimonial', testimonial);
                            return (
                                <Fade in={isVisible} timeout={1000}>
                                    <Box
                                        id={`testimonial-${index}`}
                                        sx={{
                                            width: "100%",
                                            minHeight: "600px",
                                            backgroundImage: `url(${testimonial.featuredMedia &&
                                                    testimonial.featuredMedia.source_url
                                                    ? testimonial.featuredMedia.source_url
                                                    : Background
                                                })`,
                                            backgroundSize: "cover",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            position: "relative",
                                            padding: {
                                                xs: "40px 4%",
                                                md: "100px 4%",
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                width: '96%',
                                                height: '100%',
                                                maxWidth: '1470px',
                                                left: '50%',
                                                transform: 'translate(-50%)',
                                            }}
                                        >
                                            <Fade in={isVisible} timeout={1500}>
                                                <Box
                                                    sx={{
                                                        position: {
                                                            xs: "relative",
                                                            md: "absolute",
                                                        },
                                                        right: "0%",
                                                        width: {
                                                            xs: "92%",
                                                            md: "35%",
                                                        },
                                                        backgroundColor: "rgba(256,256,256,0.9)",
                                                        padding: "70px 50px",
                                                        margin: {
                                                            xs: "0 auto",
                                                            md: "0",
                                                        },
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            width: "75px",
                                                            marginBottom: "20px",
                                                            position: "absolute",
                                                            zIndex: "1",
                                                            top: "20px",
                                                            right: "20px",
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faArrowCircleLeft}
                                                            style={{
                                                                color: "#005EAA",
                                                                fontSize: "1.5rem",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={goToPrevSlide}
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={faArrowCircleRight}
                                                            style={{
                                                                color: "#005EAA",
                                                                fontSize: "1.5rem",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={goToNextSlide}
                                                        />
                                                    </Box>
                                                    {testimonial && (
                                                        <Box
                                                            sx={{
                                                                position: "relative",
                                                            }}
                                                        >
                                                            <Box
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "-85px",
                                                                    left: "-20px",
                                                                    fontSize: "6rem",
                                                                    color: "#E9531C",
                                                                    opacity: "1",
                                                                    lineHeight: "6rem",
                                                                }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="auto" viewBox="0 0 119.602 86.563">
                                                                    <path id="Path_8118" data-name="Path 8118" d="M26.763-198.044A50.483,50.483,0,0,1,32.854-221.3q6.091-11.812,23.071-33.038l14.027,10.521Q54.817-226.468,50.2-208.564a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q26.763-184.755,26.763-198.044Zm75.674,0a50.483,50.483,0,0,1,6.091-23.256q6.091-11.812,23.071-33.038l13.843,10.521q-14.95,17.165-19.564,35.253a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q102.437-184.755,102.437-198.044Z" transform="translate(-26.763 254.338)" fill="#e9531c" opacity="0.216" />
                                                                </svg>

                                                            </Box>
                                                            <div
                                                                style={{
                                                                    fontSize: mobile ? "1rem" : "1.2rem",
                                                                    fontStyle: 'italic',
                                                                }}
                                                                dangerouslySetInnerHTML={{ __html: testimonial.content.rendered }} />
                                                            <Box
                                                                style={{
                                                                    position: "absolute",
                                                                    bottom: "20px",
                                                                    right: "20px",
                                                                    fontSize: "6rem",
                                                                    color: "#E9531C",
                                                                    opacity: "1",
                                                                    lineHeight: "6rem",
                                                                }}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="85" height="auto" viewBox="0 0 119.602 86.563">
                                                                    <path id="Path_8117" data-name="Path 8117" d="M26.763-198.044A50.483,50.483,0,0,1,32.854-221.3q6.091-11.812,23.071-33.038l14.027,10.521Q54.817-226.468,50.2-208.564a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q26.763-184.755,26.763-198.044Zm75.674,0a50.483,50.483,0,0,1,6.091-23.256q6.091-11.812,23.071-33.038l13.843,10.521q-14.95,17.165-19.564,35.253a19.592,19.592,0,0,1,14.489,6.091,20.047,20.047,0,0,1,6,14.581,19.32,19.32,0,0,1-6,14.12,20.179,20.179,0,0,1-14.858,6,19.843,19.843,0,0,1-16.8-8.49Q102.437-184.755,102.437-198.044Z" transform="translate(146.364 -167.774) rotate(180)" fill="#e9531c" opacity="0.216" />
                                                                </svg>

                                                            </Box>
                                                            {/* {testimonial.partnerLogo !== null && (
                                                        <img
                                                            src={testimonial.partnerLogo}
                                                            alt={`Testimonial ${index + 1}`}
                                                            style={{
                                                                width: "60px",
                                                                marginTop: "30px",
                                                            }}
                                                        />
                                                    )} */}
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Fade>
                                            {location && location.pathname !== "/experience/" && location.pathname !== "/about/careers/"
                                                ?
                                                <Fade in={isVisible} timeout={2000}>
                                                    <Button
                                                        component={RouterLink}
                                                        to="/experience/"
                                                        sx={{
                                                            position: {
                                                                xs: "relative",
                                                                md: "absolute",
                                                            },
                                                            left: {
                                                                xs: "unset",
                                                                md: "0%",
                                                            },
                                                            bottom: {
                                                                xs: "unset",
                                                                md: "130px",
                                                            },
                                                            transform: {
                                                                xs: "unset",
                                                                md: "translateX(0%)",
                                                            },
                                                            backgroundColor: "#E9531C",
                                                            color: "#ffffff",
                                                            borderRadius: "50px",
                                                            fontWeight: "600",
                                                            fontSize: '1.2rem',
                                                            padding: "0.5rem 1rem",
                                                            height: "50px",
                                                            top: "0px",
                                                            marginTop: {
                                                                xs: "20px",
                                                                md: "0",
                                                            },
                                                            marginLeft: {
                                                                xs: "calc(50% - 120px)",
                                                                md: "0",
                                                            },
                                                            '&:hover': {
                                                                backgroundColor: "#0C5EAA",
                                                            },
                                                        }}
                                                    >
                                                        See our client stories
                                                    </Button>
                                                </Fade>
                                                : null}
                                        </Box>
                                    </Box>
                                </Fade>
                            )
                        })}
                    </Slider>
                ) : null
            }
        </>
    );
};

export default RandomTestimonial;